import { datadogRum } from '@datadog/browser-rum';
import { type SegmentAbstraction } from '@ria-client/segment/Analytics/lib/Segment';
import type { ExperimentBucketingDecisionProps } from '@ria-client/segment/generated';
import { ExposureData } from './eventLogging';

interface BucketedEventParams {
  attributes: Record<string, string>;
  anonymousId: string | null;
  deviceId: string;
  deployableVersion?: string;
  exposureData: ExposureData[];
  gitSha: string;
}

export const logABSmartlyBucketingDecision = (
  params: BucketedEventParams,
  analytics: SegmentAbstraction,
) => {
  const segmentInstance = analytics.segmentInstance;

  if (segmentInstance) {
    params.exposureData.forEach(({ experimentKey, variationKey }) => {
      datadogRum.addFeatureFlagEvaluation(
        // The hyphen is not allowed according to DD documentation
        //  https://docs.datadoghq.com/real_user_monitoring/guide/setup-feature-flag-data-collection/?tab=browser#feature-flag-naming
        experimentKey?.replace('-', '_'),
        variationKey,
      );
      const properties: ExperimentBucketingDecisionProps = {
        bucketing_id: params.anonymousId ?? undefined,
        bucketing_id_type: 'anonymous_id',
        deployable_name: 'ria-client',
        deployable_version: params.deployableVersion ?? '1.0.0',
        experiment_key: experimentKey,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
        variation_key: variationKey,
        additional_attributes: {
          // User attributes first — they must never overwrite the fields we control.
          ...params.attributes,
          decision_location: 'client',
          traditional_device_id: params.deviceId,
        },
      };
      void segmentInstance.track('Experiment Bucketing Decision', properties, {
        context: {
          app: {
            name: 'ria-client',
            version: params.gitSha,
          },
        },
      });
    });
  }
};
